import { render, staticRenderFns } from "./modal-recommend.vue?vue&type=template&id=da50d388&"
import script from "./modal-recommend.vue?vue&type=script&lang=js&"
export * from "./modal-recommend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports